import { css } from '@compiled/react';
import { MOBILE } from '../../utils/constants';
import Forums from 'components/forums/Forums';
import { forumsV2IsActive } from '../../services/statsig/featureGates';
import { useRouter } from 'react-resource-router';

// TODO: Add PageWithAnalytics wrapper when analytics are ready
const ForumsV2Page = () => {
  const [, { push }] = useRouter();

  if (!forumsV2IsActive()) {
    push('/page-not-found');
  }

  return (
    <div css={containerStyle}>
      <Forums />
    </div>
  );
};

const containerStyle = css`
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  padding: 24px;
  ${MOBILE.MEDIA_QUERY} {
    padding: 16px;
  }
`;

export default ForumsV2Page;
